export default "__VITE_ASSET__BQqxwMpj__"